import { aludraApi, publicApi } from 'Api/axios'
import { YAPPY_PAYMENT_BASE_URL } from 'Utils/constants'

const YAPPY_PAYMENT_ENDPOINT = '/payment/api/yappy/paymentlink'
const YAPPY_LINK_STATUS_ENDPOINT = '/payment/api/yappy/link-status'
const YAPPY_BUTTON_ENDPOINT = '/payment/api/yappy/button'

export const createYappyPaymentLink = async ({
  documentId,
  documentTypeId,
  paymentTypeId,
  amount,
  phone,
}) => {
  if (!YAPPY_PAYMENT_BASE_URL) {
    throw new Error('REACT_APP_YAPPY_PAYMENT_BASE_URL is not configured')
  }
  const { data } = await aludraApi.post(YAPPY_PAYMENT_ENDPOINT, {
    AmounPay: amount,
    DocumentTypeId: documentTypeId,
    PaymentTypeId: paymentTypeId,
    DocumentId: documentId,
    Url: YAPPY_PAYMENT_BASE_URL,
    Phone: phone,
  })
  return data
}

export const getYappyLinkStatus = async transactionId => {
  const { data } = await publicApi.get(
    `${YAPPY_LINK_STATUS_ENDPOINT}/${encodeURIComponent(transactionId)}`
  )
  return data
}

export const createYappyButtonOrder = async ({ id, phone }) => {
  const { data } = await publicApi.post(YAPPY_BUTTON_ENDPOINT, {
    id,
    phone,
  })
  return data
}
